module.exports = __webpack_public_path__ + "img/Offer-banner.e05b2315.png";